import { logout } from "./methods/logout";
import { refreshToken } from "./methods/refreshToken";
import { validateEmailAddress } from "./methods/validateEmailAddress";
import { setTokens } from "./methods/setTokens";
import { isLoggedIn } from "./methods/isLoggedIn";
import { init, setShouldUseCheggMfaToken } from "./methods/init";
import { login } from "./methods/login";
import { signup } from "./methods/signup";
import { ssoLogin } from "./methods/ssoLogin";
import { ssoSignup, ssoAuthTokens } from "./methods/ssoSignup";
import { resetPassword } from "./methods/resetPassword";
import { sendResetPasswordEmail } from "./methods/sendResetPasswordEmail";
import { doMfa, sendEmail, getMfaToken, isUserMfa } from "./methods/mfa";
import { listen, removeListener, onError } from "./utils/eventManager";
import { getAuthGateUrl, getCookieDomain } from "./utils/config";
import { authenticateMfa } from "./methods/authenticateMfa";
import { MfaRequiredError, GqlError, ApwError, PxError, isGqlError, isPxError, isApwError } from "./utils/GqlError";
import { pollMfaByAppStatus, abortPolling } from "./methods/mfaStatus";
import { sendAppMfaCode } from "./methods/sendAppMfaCode";
import { ErrorCodes, SsoProviders, Mfa_Status } from "./__generated__/auth-gate";
import { Environment, getClientId, setClientId } from "./utils/config";
import { StudentType, UserType, TokenType, ResetPasswordStatus } from "./__generated__/auth-gate";
export { init, doMfa, login, logout, listen, signup, onError, PxError, GqlError, Mfa_Status, ssoLogin, ApwError, UserType, getCookieDomain, TokenType, ssoSignup, ssoAuthTokens, setTokens, sendEmail, isUserMfa, isLoggedIn, ErrorCodes, Environment, StudentType, setClientId, getClientId, getMfaToken, SsoProviders, validateEmailAddress, refreshToken, resetPassword, removeListener, getAuthGateUrl, ResetPasswordStatus, sendResetPasswordEmail, MfaRequiredError, pollMfaByAppStatus, abortPolling, sendAppMfaCode, isGqlError, isPxError, isApwError, setShouldUseCheggMfaToken, authenticateMfa };
export var Errors = {
  GqlError: GqlError,
  ApwError: ApwError,
  MfaRequiredError: MfaRequiredError
};
var OneAuthSDK = {
  init: init,
  doMfa: doMfa,
  login: login,
  listen: listen,
  logout: logout,
  signup: signup,
  Errors: Errors,
  ssoLogin: ssoLogin,
  sendEmail: sendEmail,
  ssoSignup: ssoSignup,
  ssoAuthTokens: ssoAuthTokens,
  setTokens: setTokens,
  isLoggedIn: isLoggedIn,
  ErrorCodes: ErrorCodes,
  getMfaToken: getMfaToken,
  refreshToken: refreshToken,
  SsoProviders: SsoProviders,
  validateEmailAddress: validateEmailAddress,
  resetPassword: resetPassword,
  removeListener: removeListener,
  sendResetPasswordEmail: sendResetPasswordEmail
};
export default OneAuthSDK;